import React from 'react';
import Button from 'components/Button';
import history from 'routing/history';
import EggAboutToHatch from 'products/global/assets/img/nest/egg-about-to-hatch.png';

export const NOTIFICATIONS = {
  REFERRAL_ACTIVATED: {
    button: (text, onClick) => (
      <Button onClick={onClick} variant="primary">
        {text}
      </Button>
    ),
    onButtonClick: () => {
      history.push('/nomad-insurance/profile/invites');
    },
    imageSrc: EggAboutToHatch
  },
  GIFT_CARD_TWO_WAY: {
    button: (text, onClick) => (
      <Button onClick={onClick} variant="primary">
        {text}
      </Button>
    ),
    onButtonClick: () => {
      history.push('/nomad-insurance/profile/invites');
    }
  },
  GIFT_CARD_ONE_WAY: {
    button: (text, onClick) => (
      <Button onClick={onClick} variant="primary">
        {text}
      </Button>
    ),
    onButtonClick: () => {
      history.push('/nomad-insurance/profile/invites');
    }
  },
  REFERRAL_VOUCHER_RETURNED: {
    button: (text, onClick) => (
      <Button variant="primary" onClick={onClick}>
        {text}
      </Button>
    ),
    onButtonClick: () => {
      history.push('/nomad-insurance/profile/invites');
    }
  },
  REFERRAL_VOUCHER_EXCLUDED: {
    button: (text, onClick) => (
      <Button variant="primary" onClick={onClick}>
        {text}
      </Button>
    )
  }
};

export const NOTIFICATION_TEXTS = {
  REFERRAL_ACTIVATED: {
    title: 'Your egg has hatched! You can now give someone $15 to earn $15 back yourself',
    description:
      'Thanks for continuing to be a loyal member at SafetyWing. We have awarded you with 3 x $15 gift cards you can give to your friends. When someone buys their own Nomad Insurance using your gift card, you will get a $15 gift card added to your account  as well, and it will automatically be applied to your next Nomad Insurance payment. (gift-cards are valid for first time customers only. Receiver can not have USA or Canada citizenship, home country or destination).',
    buttonText: 'Share gift cards'
  },
  GIFT_CARD_TWO_WAY: {
    title: 'You have gift cards to give away! Give them away get your own in return.',
    description:
      'Thanks for continuing to be a loyal member at SafetyWing. We have awarded you with 3 x $15 gift cards you can give to your friends. When someone buys their own Nomad Insurance using your gift card, you will get a $15 gift card added to your account  as well, and it will automatically be applied to your next Nomad Insurance payment. (gift-cards are valid for first time customers only. Receiver can not have USA or Canada citizenship, home country or destination).',
    buttonText: 'Share gift cards'
  },
  GIFT_CARD_ONE_WAY: {
    title: 'Hi! You have received Gift Cards to give away.',
    description:
      'Thanks for continuing to be a loyal member at SafetyWing. We have given you 3 x $30 gift cards that you can give away to friends. (valid for first time customers only. Receiver can not have USA or Canada citizenship, home country or destination).',
    buttonText: 'Share gift cards'
  },
  REFERRAL_VOUCHER_RETURNED: {
    title: 'Your gift card was returned',
    description:
      'A gift card you sent was returned unused. You can re-share the gift card if you wish.',
    buttonText: 'Share gift cards'
  },
  REFERRAL_VOUCHER_EXCLUDED: {
    title: 'Your gift card was returned',
    description:
      'Sorry, but because of insurance industry regulations, we can’t distribute gift cards to US or Canadian citizens or residents :( Your gift card has been returned to your giver.',
    buttonText: 'Okay'
  }
};
